import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSandwich, faWave } from '@fortawesome/pro-solid-svg-icons';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-lines-cell-renderer',
  standalone: true,
  imports: [FontAwesomeModule, Tooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (count > 0) {
      <span>
        {{ count }}
        @if (validationRemarks.length > 0) {
          <i
            class="pi pi-exclamation-triangle text-orange-500 ml-2 cursor-help"
            [pTooltip]="validationRemarksText"
            tooltipPosition="top"></i>
        }
        @if (hasSeaside) {
          <fa-icon
            [icon]="faWawe"
            pTooltip="Seaside Extension"
            tooltipPosition="top"
            class="text-xl ml-2 cursor-help"></fa-icon>
        }
        @if (hasAnodic) {
          <img
            src="assets/icons/preox_icon.svg"
            alt="Anodic extension"
            pTooltip="Pre-Ox Extension"
            tooltipPosition="top"
            style="width: 1.5em; height: 1.3em; margin-left: 0.5rem;"
            class="cursor-help" />
        }
        @if (hasPostforming) {
          <fa-icon
            [icon]="faSandwich"
            pTooltip="Postforming Extension"
            tooltipPosition="top"
            class="text-xl ml-2 cursor-help"></fa-icon>
        }
      </span>
    }
    @if (count === 0) {
      <span>-</span>
    }
  `,
})
export class LinesCellRendererComponent implements ICellRendererAngularComp {
  faSandwich = faSandwich;
  faWawe = faWave;
  count = 0;
  hasSeaside = false;
  hasAnodic = false;
  hasPostforming = false;
  validationRemarks: string[] = [];
  validationRemarksText = '';

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const value = params.value;
    if (value) {
      this.count = value.count || 0;
      this.hasSeaside = value.hasSeaside || false;
      this.hasAnodic = value.hasAnodic || false;
      this.hasPostforming = value.hasPostforming || false;
      this.validationRemarks = value.validationRemarks || [];
      this.validationRemarksText = this.validationRemarks.join('\n');
    } else {
      this.count = 0;
      this.hasSeaside = false;
      this.hasAnodic = false;
      this.hasPostforming = false;
      this.validationRemarks = [];
      this.validationRemarksText = '';
    }
    return true;
  }
}
